import DataSharingEditor from './dataSharing/DataSharingEditor.js';
export default {
  install: molten => {
    DataSharingEditor.install(molten);
  }
};